import { useNuxtApp } from "#imports";
import { createSupabaseClient } from "../utils/client.mjs";
import { useSupabaseToken } from "../composables/useSupabaseToken.mjs";
export const useSupabaseClient = () => {
  const nuxtApp = useNuxtApp();
  const token = useSupabaseToken();
  const Authorization = token.value ? `Bearer ${token.value}` : void 0;
  const recreateClient = nuxtApp._supabaseClient?.headers.Authorization !== Authorization;
  if (!nuxtApp._supabaseClient || recreateClient) {
    nuxtApp._supabaseClient = createSupabaseClient();
  }
  return nuxtApp._supabaseAuthClient;
};
